import PageMeta from "../../components/common/PageMeta";
import ReservationReqs from "../../components/hotel/ReservationReqs";

export default function Reservations() {
    return (
        <>
        <PageMeta
            title="Reservation Requests - SelfServe"
            description="SelfServe Reservation Requests Dashboard"
        />
        <div className="col-span-12">
            <ReservationReqs/>
        </div>
        </>
    );
}